import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-process-pending",
  "use": "svg_i-process-pending-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-process-pending\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FDCB0F\" cx=\"9\" cy=\"9\" r=\"9\" /><path d=\"M13.906 9.171a4.91 4.91 0 1 0-5.077 4.735\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol